// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const donphan: PokeData = {
  "id": 232,
  "name": "donphan",
  "height": 11,
  "weight": 1200,
  "base_experience": 175,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "slam",
    "horn-attack",
    "fury-attack",
    "tackle",
    "take-down",
    "double-edge",
    "growl",
    "earthquake",
    "defense-curl",
    "flail",
    "scary-face",
    "endure",
    "charm",
    "rollout",
    "magnitude",
    "rapid-spin",
    "knock-off",
    "odor-sleuth",
    "rock-tomb",
    "assurance",
    "last-resort",
    "giga-impact",
    "thunder-fang",
    "fire-fang",
    "bulldoze",
    "stomping-tantrum"
  ],
  "moves": [
    "tackle",
    "growl",
    "earthquake",
    "scary-face",
    "magnitude",
    "rock-tomb",
    "thunder-fang",
    "fire-fang",
    "mud-slap",
    "earth-power",
    "mud-bomb",
    "mud-shot",
    "rototiller"
  ],
  "evolution_chain": {
    "id": 119,
    "item": null,
    "species": [
      {
        "name": "phanpy",
        "order": 263,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "donphan",
        "order": 264,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 231,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 138,
    "speed": 77,
    "ability_power": 185
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
